import React from 'react'

import {
  Icon,
  Dollar,
  Payment,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, oneOf, string } from 'prop-types'

import CalendarDollarIcon from 'Pods/Shared/Icons/CalendarDollarIcon'
import CalendarEventIcon from 'Pods/Shared/Icons/CalendarEventIcon'

const ICON_MAP = {
  billingCycle: CalendarDollarIcon,
  renewsOn: CalendarEventIcon,
  price: Dollar,
  payment: Payment,
}

const VARIANT_CLASSES = {
  default: { label: 'cgt-text-medium', value: 'cgt-text-medium cgt-text-medium--semi-bold' },
  restructure: {
    label: 'cgt-body-md billing-info-item__label--restructure',
    value: 'cgt-body-md-semibold billing-info-item__value--restructure',
  },
}

function BillingInfoItem({
  iconType, label, value, action = null, variant = 'default',
}) {
  const IconComponent = ICON_MAP[iconType]
  const isRestructure = variant === 'restructure'
  const classes = VARIANT_CLASSES[variant]

  return (
    <div className={classnames('billing-info-item', isRestructure && 'billing-info-item--restructure')}>
      {IconComponent && (
        <Icon
          svgComponent={IconComponent}
          color="dark"
          size="small"
          className={classnames('gt-mr-0', isRestructure && 'billing-info-item__icon')}
        />
      )}
      <span className={`${classes.label} billing-info-item__label`}>{label}:</span>
      <span className={`${classes.value} billing-info-item__value`}>{value}</span>
      {action}
    </div>
  )
}

BillingInfoItem.propTypes = {
  iconType: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  action: node,
  variant: oneOf(['default', 'restructure']),
}

export default BillingInfoItem
